import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({ label = 'Loading', minHeight = 'min-h-[400px]' }) => (
  <div
    className={`flex flex-col items-center justify-center w-full h-full ${minHeight}`}
    role="status"
    aria-live="polite"
    aria-label={label}
  >
    <div className="relative w-16 h-16" aria-hidden="true">
      <div className="absolute inset-0 rounded-full border-4 border-orange-500/20" />
      <div className="absolute inset-0 rounded-full border-4 border-t-orange-500 border-r-transparent border-b-transparent border-l-transparent animate-spin" />
    </div>
    <p className="mt-4 text-sm text-white/60">{label}</p>
  </div>
);

Loader.propTypes = {
  label: PropTypes.string,
  minHeight: PropTypes.string,
};

export default Loader;
